import { render } from "./categoryComponent.vue?vue&type=template&id=733676ba"
import script from "./categoryComponent.vue?vue&type=script&lang=js"
export * from "./categoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\VR-DEV001\\Documents\\repositorios\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__